// Export services data with icons and categories
export const services = [
  { 
    title: 'Mobile App Development', 
    desc: 'Android & iOS development with modern stacks and CI/CD.',
    icon: '📱',
    category: 'Development',
    color: '#3b82f6'
  },
  { 
    title: 'ERP Development', 
    desc: 'Modular, scalable ERP tailored to business workflows.',
    icon: '⚙️',
    category: 'Enterprise',
    color: '#8b5cf6'
  },
  { 
    title: 'Business Software', 
    desc: 'Custom line-of-business apps, integrations and automation.',
    icon: '💼',
    category: 'Business',
    color: '#06b6d4'
  },
  { 
    title: 'Web Development', 
    desc: 'Responsive websites and web apps with modern frameworks.',
    icon: '🌐',
    category: 'Development',
    color: '#10b981'
  },
  { 
    title: 'Cloud Solutions', 
    desc: 'AWS, Azure and GCP services for scalability and cost-efficiency.',
    icon: '☁️',
    category: 'Cloud',
    color: '#f59e0b'
  },
  { 
    title: 'Data Analytics', 
    desc: 'Data pipelines, visualization and machine learning solutions.',
    icon: '📊',
    category: 'Analytics',
    color: '#ef4444'
  },
  { 
    title: 'Cybersecurity', 
    desc: 'Security assessments, compliance and incident response.',
    icon: '🔒',
    category: 'Security',
    color: '#6366f1'
  },
  { 
    title: 'IT Consulting', 
    desc: 'Strategy, architecture and project management services.',
    icon: '🎯',
    category: 'Consulting',
    color: '#ec4899'
  },
  { 
    title: 'Support & Maintenance', 
    desc: 'Ongoing support, monitoring and optimization for IT systems.',
    icon: '🛠️',
    category: 'Support',
    color: '#84cc16'
  },
  { 
    title: 'Training & Workshops', 
    desc: 'Hands-on training in software development and cloud technologies.',
    icon: '🎓',
    category: 'Education',
    color: '#0ea5e9'
  },
  { 
    title: 'Digital Transformation', 
    desc: 'End-to-end solutions for modernizing business processes.',
    icon: '🚀',
    category: 'Transformation',
    color: '#f97316'
  },
  { 
    title: 'Custom Integrations', 
    desc: 'APIs, middleware and system integrations for seamless workflows.',
    icon: '🔗',
    category: 'Integration',
    color: '#14b8a6'
  },
  { 
    title: 'E-commerce Solutions', 
    desc: 'Full-stack e-commerce platforms with payment integration.',
    icon: '🛒',
    category: 'E-commerce',
    color: '#a855f7'
  },
  
];